import { useMutation } from "@suse-o11y/query";
import React from "react";

import type { MonitorCheckStatusConfiguredSilencingRule } from "../../../../../../../common/openapi";
import { deleteSilencingRule } from "../../../../../../../queries/silencing-rules";
import { useUnmuteDrawerContext } from "../context";

export function RemoveRuleAction({ rule }: { rule: MonitorCheckStatusConfiguredSilencingRule }) {
	const { onDelete } = useUnmuteDrawerContext();

	const { mutate: removeRule, isLoading } = useMutation({
		onSuccess: () => {
			onDelete();
		},
		...deleteSilencingRule,
	});

	return (
		<button
			aria-busy={isLoading}
			className="button button-secondary w-fit uppercase"
			onClick={() => {
				if (!isLoading) {
					removeRule(rule.identifier);
				}
			}}
			type="button"
		>
			Remove silencing rule
		</button>
	);
}
